import Vue from 'vue'
import Vuex from 'vuex'
import $axios from './api.js'
Vue.use(Vuex)

const state = {
  sidebarShow: 'responsive',
  sidebarMinimize: false,

  token: localStorage.getItem('token'),
  customer: {},
  setting: {},
  errors: [],
}

const mutations = {
  toggleSidebarDesktop (state) {
    const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarOpened ? false : 'responsive'
  },
  toggleSidebarMobile (state) {
    const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarClosed ? true : 'responsive'
  },
  set (state, [variable, value]) {
    state[variable] = value
  },

  SET_TOKEN(state, payload) {
    state.token = payload
  },
  SET_CUSTOMER(state,payload){
    state.customer = payload
  },
  SET_SETTING(state,payload){
    state.setting = payload
  },
  SET_ERRORS(state, payload) {
    state.errors = payload
  },
  CLEAR_ERRORS(state) {
    state.errors = []
  },
}

const actions = {
    getCustomer({state,commit}){
      return new Promise((resolve,reject) => {
          $axios.get('/customer')
          .then((response) => {
              commit('SET_CUSTOMER', response.data.data)
              resolve(response.data)
          }).catch((error) => {
              reject(error.response)
          })
      })
  },
  getSetting({state,commit}){
      return new Promise((resolve,reject) => {
          $axios.get('/setting')
          .then((response) => {
              commit('SET_SETTING', response.data.data)
              resolve(response.data)
          }).catch((error) => {
              reject(error.response)
          })
      })
  },
}

const getters = {
  isAuth: state => {
    return state.token != "null" && state.token != null
  }
}

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters
})